angular.module("Main").controller("PaymentTerminSuccessController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "$localStorage", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, $localStorage, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            //unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
        });

        vm.bookingLost = false;
        vm.cashBack = false;
        vm.cookies = SessionService.checkSession();
        vm.currentUser = $localStorage.user;

        getKursbuchungLayouKonfiguration();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = false;
        vm.isTermin = true;
        vm.isPayment = true;

        if (!SessionService.getSessionId()) {
            $state.go("angebot", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;
            let userData = $localStorage.user;
            BookingService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                if (status.status === 'TIMEOUT') {
                    vm.bookingLost = true;
                    if (status.PaymentFinished === true) {
                        vm.cashBack = true;
                    }
                    PaymentService.timeoutPayment(status.requestId);
                } else {
                    vm.dataMeeting = ({
                        OrderNr: $stateParams.oid,
                        Name: vm.status.artikel,
                        PreisZahl: vm.status.preis,
                        Day: vm.status.start,
                        End: vm.status.ende,
                        PersonNr: vm.status.personNr,
                        RessourcenIds: vm.status.ressourcesIds,
                        TerminNr: vm.status.terminNr
                    });
                    if (!status.confirmed && status.status !== "ERROR") {
                        PaymentService.confirmPayment($stateParams.rid).then(function () {
                            if (!_.isNil($stateParams.oid))
                                BookingService.confirmReservation($stateParams.oid, $translate.use()).then(function (data) {
                                    vm.isPayment = true;
                                    vm.zahlmethode = 'SixPayments';
                                    if ((data && !_.isEmpty(data.rechnungsNr)) ) {
                                        vm.dataMeeting.RechnungsNr = data.rechnungsNr;
                                    }
                                    if(data.data && !_.isEmpty(data.data.rechnungsNr)) {
                                        vm.dataMeeting.RechnungsNr = data.data.rechnungsNr;
                                    }
                                    getDataByRIDForConfirm();
                                    BookingService.saveAppointmentHistory(vm.dataMeeting.TerminNr, 1, 5);
                                    BookingService.saveAppointmentHistory(vm.dataMeeting.TerminNr, 8, 5,
                                        {orderId: $stateParams.oid});
                                }).catch(function (error) {
                                    $state.go("booking_termin_error", {cid: SessionService.getAuthData(), message: error, id: SessionService.getAuthIdData(), oid: $stateParams.oid});
                                    vm.hasError = true;
                                })
                        }).catch(function () {
                            vm.hasError = true;
                        })
                    }
                }
            });

            vm.remindLocalePayment = $stateParams.locale;
        }

        function getDataByRIDForConfirm() {
            vm.member = {};
            SessionService.setAuthData($stateParams.cid, $stateParams.id);
            BookingService.getUserDataByRIDForConfirm($stateParams.rid).then(function (data) {
                vm.member.email = data.email;
                vm.member.firstName = data.firstname;
                vm.member.lastName = data.lastname;
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.username = data.firstname + " " + data.lastname;
                    vm.hideLogin = true;
                    $rootScope.$emit("login");
                }
            }).then(function () {
                var arr =  vm.dataMeeting.RessourcenIds.slice(1, -1);
                var ids = _.split(arr, '"');
                BookingService.getResourceNames(vm.cookies.meetingDate).then(function (data) {
                    let MitarbeiterRessource = _.sortBy(_.filter(data, {Mitarbeiter: 1}), 'Bezeichnung');
                    let NichtMitarbeiterRessource = _.sortBy(_.filter(data, {Mitarbeiter: 0}), 'Bezeichnung');
                    vm.dataMeeting.ressources = _.concat(MitarbeiterRessource, NichtMitarbeiterRessource);
                }).then(function () {
                    vm.meetingData = vm.dataMeeting;
                    let end = vm.meetingData.End;
                    let timeEnd = moment(vm.meetingData.End).format("HH:mm");
                    if(timeEnd === '00:00') {
                        let newEnd = moment(end).subtract('minutes', 1).format();
                        vm.meetingData.End = new Date(newEnd);
                    }
                })
            });
        }


        //Wird schon in dem endpoint confirm gemacht
        function bookIntoMV() {
            PaymentService.saveMVBooking($stateParams.oid, $translate.use()).then(function (data) {
                if ((data && !_.isEmpty(data.rechnungsNr)) ) {
                    vm.meetingData.RechnungsNr = data.rechnungsNr;
                }
                if(data.data && !_.isEmpty(data.data.rechnungsNr)) {
                    vm.meetingData.RechnungsNr = data.data.rechnungsNr;
                }
            })
        }

    }]);
